import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  if (!loading && user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setSubmitting(true);
    const r = await login(email, password);
    setSubmitting(false);
    if (r.ok) nav("/admin");
    else setError(r.error || "Login failed");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--opus-bg)" }}>
      <div className="w-full max-w-md">
        <p className="text-xs tracking-[0.28em] uppercase text-center" style={{ color: "var(--opus-sage)" }}>Opus Resources</p>
        <h1 className="font-serif text-4xl md:text-5xl text-center mt-3" data-testid="admin-login-title" style={{ fontWeight: 500 }}>
          Admin sign-in
        </h1>

        <form onSubmit={submit} className="opus-card p-8 mt-10" data-testid="admin-login-form">
          <label className="text-xs uppercase tracking-[0.2em] block mb-2">Email</label>
          <input
            type="email"
            data-testid="admin-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="opus-input"
            placeholder="admin@opusbusinessoperations.com"
          />

          <label className="text-xs uppercase tracking-[0.2em] block mb-2 mt-5">Password</label>
          <input
            type="password"
            data-testid="admin-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="opus-input"
          />

          {error ? <p className="text-sm mt-4" data-testid="admin-login-error" style={{ color: "#A0392C" }}>{error}</p> : null}

          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="btn-sage w-full mt-6 py-3 text-xs tracking-[0.22em] uppercase disabled:opacity-50"
            style={{ borderRadius: "2px" }}
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
